const globalStyles = {
  '.chakraTaggedTextarea': {
    height: 'auto',
    marginBottom: '8px',
    fontSize: '14px',

    textarea: {
      minHeight: '80px !important',
      maxHeight: '300px !important',
      resize: 'none',
      boxSizing: 'border-box',
      transition: 'border-color 0.2s ease',
      overflowY: 'auto !important',
      borderRadius: 'var(--chakra-radii-md)',

      '&:focus': {
        outline: 'none',
        outlineOffset: '-2px',
        outlineWidth: 'var(--focus-ring-width, 1px)',
        outlineColor: 'var(--chakra-colors-gray-400)',
        outlineStyle: 'var(--focus-ring-style, solid)',
        borderColor: 'var(--chakra-colors-gray-400)',
      },
    },
  },

  '.chakraTaggedTextarea__control': {
    minHeight: '80px !important',
    maxHeight: '300px !important',
    overflowY: 'auto !important',
    resize: 'none',
    lineHeight: '1.5',

    '&:focus-within': {
      outline: 'none',
      borderColor: 'var(--focus-ring-color)',
      boxShadow: 'inset 0 0 0 1px var(--focus-ring-color)',
    },
  },

  '.chakraTaggedTextarea__highlighter': {
    padding: '8px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    height: '79px',
    border: '1px solid transparent',
    outline: 'none',
  },

  '.chakraTaggedTextarea__input': {
    border: '1px solid var(--chakra-colors-gray-300)',
    resize: 'none',
    outline: 'none',
    height: '79px',
    overflow: 'auto !important',
    padding: '8px',
    color: 'var(--chakra-colors-gray-700)',
    backgroundColor: 'var(--chakra-colors-bg)',

    '&:focus': {
      borderColor: 'var(--focus-ring-color)',
      boxShadow: 'inset 0 0 0 1px var(--focus-ring-color)',
    },

    '&::placeholder': {
      color: 'var(--chakra-colors-gray-400)',
      opacity: '1',
    },

    '&::selection': {
      background: 'var(--chakra-colors-blue-100)',
    },
  },

  '.chakraTaggedTextarea__singleLine': {
    maxHeight: 'none !important',
  },

  '.chakraTaggedTextarea__suggestions': {
    backgroundColor: 'var(--chakra-colors-bg)',
    border: '1px solid var(--chakra-colors-border-muted)',
    boxShadow: 'var(--chakra-shadows-md)',
    borderRadius: 'var(--chakra-radii-md)',
    maxHeight: '320px !important',
    overflowY: 'auto !important',
    fontSize: '14px',

    '&:hover': {
      backgroundColor: 'var(--chakra-colors-bg-subtle)',
    },
  },

  '.chakraTaggedTextareaSuggestion': {
    position: 'relative',
    zIndex: '1',
    color: 'var(--chakra-colors-blue-fg)',
    textDecoration: 'underline',
    pointerEvents: 'none',
    backgroundColor: 'var(--chakra-colors-bg-subtle)',
  },
};

export default globalStyles;
